import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  Box,
  VStack,
  Flex,
  Text,
  Icon,
  Badge,
  useColorMode
} from '@chakra-ui/react';
import { 
  FiHome, 
  FiSearch, 
  FiCpu, 
  FiUsers, 
  FiCreditCard,
  FiBarChart2
} from 'react-icons/fi';
import './Sidebar.css';

const Sidebar = () => {
  const location = useLocation();
  const { colorMode } = useColorMode();
  
  // Menu items configuration with icons
  const menuItems = [
    { path: '/', label: 'Dashboard', icon: FiHome },
    { path: '/explorer', label: 'Explorer', icon: FiSearch },
    { path: '/ai', label: 'Desol AI', icon: FiCpu },
    { path: '/governance', label: 'Governance', icon: FiUsers },
    { path: '/wallet', label: 'Wallet & Rewards', icon: FiCreditCard, badge: { text: 'New', color: 'green' } },
    { path: '/token', label: 'DESOL Token', icon: FiBarChart2, badge: { text: 'New', color: 'purple' } },
  ];

  return (
    <Box 
      as="aside" 
      bg="#1a1a2e"
      borderRight="1px solid #30304e"
      w={{ base: '70px', md: '200px' }}
      h="calc(100vh - 70px)"
      position="sticky"
      top="70px"
      className="sidebar"
      display={{ base: 'none', md: 'block' }}
    >
      <Flex direction="column" h="100%" py={5}>
        <VStack spacing={2} align="stretch" px={2}>
          {menuItems.map((item) => (
            <NavLink 
              key={item.path} 
              to={item.path} 
              className={({ isActive }) => 
                `sidebar-navlink ${isActive ? 'active' : ''}`
              }
            >
              {({ isActive: navActive }) => (
                <Flex
                  align="center"
                  px={3}
                  py={2.5}
                  borderRadius="md"
                  color={navActive ? '#7678ED' : '#a9a9c8'}
                  bg={navActive ? 'rgba(118, 120, 237, 0.1)' : 'transparent'}
                  _hover={{ bg: 'rgba(118, 120, 237, 0.06)', color: navActive ? '#7678ED' : 'white' }}
                  transition="all 0.2s"
                >
                  <Icon as={item.icon} boxSize={5} />
                  <Text 
                    ml={3} 
                    fontWeight={navActive ? 'medium' : 'normal'}
                    display={{ base: 'none', md: 'block' }}
                    fontSize="sm"
                  >
                    {item.label}
                  </Text>
                  {item.badge && (
                    <Badge 
                      ml="auto" 
                      colorScheme={item.badge.color}
                      display={{ base: 'none', md: 'block' }}
                      fontSize="10px"
                      px={1.5}
                      py={0.5}
                      borderRadius="full"
                    >
                      {item.badge.text}
                    </Badge>
                  )}
                </Flex>
              )}
            </NavLink>
          ))}
        </VStack>
      </Flex>
    </Box>
  );
};

export default Sidebar;